import { motion } from 'framer-motion'
import { mq, pxToRem, sizes } from 'src/theme'
import styled from 'styled-components'

import ActionButton from '../../ActionButton'
import Picture from '../../Picture'
import RichText from '../../RichText'

export const Container = styled.hgroup<{ $color?: string }>`
  --hero_text_title-offset: 160%;
  --hero_text_text-offset: 160%;
  display: grid;
  gap: ${pxToRem(24)};
  justify-content: center;
  background-color: ${({ $color }) => $color};
  grid-template-columns: calc(100% - ${pxToRem(16)} * 2);
  padding-block-start: calc(var(--g_height__header) + ${pxToRem(80)});
  padding-block-end: ${pxToRem(80)};

  @media ${mq(sizes.desktop)} {
    --hero_text_text-offset: 105%;
    grid-template-columns: calc(100% - ${pxToRem(32)} * 2);
    padding-block-start: calc(var(--g_height__logo) + ${pxToRem(104)});
    padding-block-end: ${pxToRem(104)};
  }
`

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.m375_h1}
  text-wrap: balance;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_h1}
    max-width: calc(100% / 3 * 2);
  }
`
export const TextContent = styled(motion.span)`
  display: block;
  @media ${mq(sizes.desktop)} {
    &:not(:only-child) {
      max-width: max(${pxToRem(564)}, calc(564 / 1376 * 100%));
    }
  }
`

export const Content = styled.div`
  ${({ theme }) => theme.textStyles.m375_bodyBig}
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  width: 100%;
  max-width: calc(223 / 343 * 100%);
  margin-inline-start: auto;
  overflow: hidden;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_bodyBig}
    max-width: calc(100% / 3 * 2);
    flex-flow: row;
  }
`
export const _RichText = styled(RichText)`
  ${({ theme }) => theme.textStyles.d1440_body}
`
export const _Picture = styled(Picture)``

export const ActionContent = styled(motion.span)`
  @media ${mq(sizes.desktop)} {
    margin-inline-start: auto;
  }
`
export const _ActionButton = styled(ActionButton)`
  white-space: nowrap;
  align-self: flex-start;
`
